/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Query Header PartialItem
 */
export type QueryHeaderPartialItem = {
    /**
     * API Response Version
     */
    _ver?: number;
    /**
     * Record Unique ID
     */
    id?: number;
    /**
     * Unix Timestamp - To Seconds Precision
     */
    created?: number;
    /**
     * Unix Timestamp - To Seconds Precision
     */
    updated?: number;
    /**
     * Unix Timestamp - To Seconds Precision
     */
    inviteTime?: number;
    /**
     * Question Count
     */
    questionCount?: number;
    /**
     * Query Header Question Builder
     */
    questionBuilder?: string;
    /**
     * Survey Header ID
     */
    surveyId?: number;
    /**
     * Survey URL
     */
    questionUrl?: string;
    /**
     * Query Close Time if manually set by CSR - Unix Timestamp - To Seconds Precision
     */
    queryCloseTime?: number;
    /**
     * Flag for prevent expert selction automation
     */
    preventInvite?: boolean;
    /**
     * Flag for CSR Quality Review
     */
    csrReview?: boolean;
    /**
     * Flag for Test Query
     */
    isTest?: boolean;
    /**
     * Query Header Text
     */
    text?: string;
    /**
     * User ID
     */
    userId?: number;
    /**
     * Diagnosis ID
     */
    diagnosisId?: number;
    /**
     * Plan Id
     */
    planId?: number;
    /**
     * Grant Id
     */
    grantId?: number;
    /**
     * Pool Id
     */
    poolId?: number;
    /**
     * type
     */
    type?: QueryHeaderPartialItem.type;
    /**
     * Query Status
     */
    status?: QueryHeaderPartialItem.status;
    /**
     * Media Type of Query
     */
    mediaType?: QueryHeaderPartialItem.mediaType;
}

export namespace QueryHeaderPartialItem {

    /**
     * type
     */
    export enum type {
        NORMAL = 'normal',
        BLINDED = 'blinded',
        COMMUNAL = 'communal',
        PRIVATE = 'private',
    }

    /**
     * Query Status
     */
    export enum status {
        OPEN = 'open',
        CLOSED = 'closed',
        ANSWERED = 'answered',
        HELD = 'held',
        PENDING_CHARGE = 'pending_charge',
        CHARGED = 'charged',
        CREATE = 'create',
        CSRHOLD = 'csrhold',
        CANCELLED = 'cancelled',
        PENDING_SURVEY = 'pending_survey',
    }

    /**
     * Media Type of Query
     */
    export enum mediaType {
        MESSENGER = 'messenger',
        AUDIO = 'audio',
        VIDEO = 'video',
    }


}
